import React, { useState, useEffect } from "react";
import auth from "auth";
import { DashboardContext } from "./dashboardContext";

export default function DashboardProvider({ children }) {
  const [checked_keys, setCheckedKeys] = useState([]);
  const [dashboard_list, setDashboardList] = useState([]);
  const [selectedDB, setSelectedDB] = useState();
  return (
    <DashboardContext.Provider
      value={{
        dashboard_list,
        setDashboardList,
        selectedDB,
        setSelectedDB,
        checked_keys,
        setCheckedKeys,
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
}
